import * as types from 'store/modules/stdapplinf/mutation-types'
import stdapplinf from 'api/stdapplinf'
import swal from 'sweetalert'
import stdapplinfLabels from 'assets/labels/stdapplinf'
import { stdapplinfColumns } from 'assets/columns/stdapplinf'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    labels: stdapplinfLabels,
    columns: stdapplinfColumns(),
    index: {
      tapplinf: {
        numappl: '',
        desc_numappl: ''
      },
      tapplfm: {
        namfathr: ''
      },
      tapphinv: {
        total: 0,
        rows: []
      },
      teducatn: {
        total: 0,
        rows: []
      },
      tapplch: {
        total: 0,
        rows: []
      },
      tapplwex: {
        total: 0,
        rows: []
      },
      ttrainbf: {
        total: 0,
        rows: []
      },
      tcmptncy: {
        total: 0,
        rows: []
      },
      tappldoc: {
        total: 0,
        rows: []
      },
      tapplref: {
        total: 0,
        rows: []
      },
      tapploth: {
        reason: ''
      }
    },
    tappoinf: {
      total: 0,
      rows: []
    }
  },
  getters: {
    [types.GET_STDAPPLINF_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_STDAPPLINF_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_STDAPPLINF_LABELS] (state) {
      return state.labels
    },
    [types.GET_STDAPPLINF_INDEX] (state) {
      return state.index
    },
    [types.GET_STDAPPLINF_TAPPOINF] (state) {
      return state.tappoinf
    }
  },
  mutations: {
    [types.SET_STDAPPLINF_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_STDAPPLINF_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].pg3 = configLabel.replaceLabelToColumns(state.columns[keyLang].pg3, labels[keyLang])
        state.columns[keyLang].pg20t1 = configLabel.replaceLabelToColumns(state.columns[keyLang].pg20t1, labels[keyLang])
        state.columns[keyLang].pg20t2 = configLabel.replaceLabelToColumns(state.columns[keyLang].pg20t2, labels[keyLang])
        state.columns[keyLang].pg7 = configLabel.replaceLabelToColumns(state.columns[keyLang].pg7, labels[keyLang])
        state.columns[keyLang].pg8 = configLabel.replaceLabelToColumns(state.columns[keyLang].pg8, labels[keyLang])
        state.columns[keyLang].pg9 = configLabel.replaceLabelToColumns(state.columns[keyLang].pg9, labels[keyLang])
        state.columns[keyLang].pg12 = configLabel.replaceLabelToColumns(state.columns[keyLang].pg12, labels[keyLang])
        state.columns[keyLang].pg13 = configLabel.replaceLabelToColumns(state.columns[keyLang].pg13, labels[keyLang])
        state.columns[keyLang].pg14 = configLabel.replaceLabelToColumns(state.columns[keyLang].pg14, labels[keyLang])
      }
    },
    [types.SET_STDAPPLINF_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_STDAPPLINF_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_STDAPPLINF_TAPPOINF] (state, data) {
      state.tappoinf = data
    }
  },
  actions: {
    [types.TOGGLE_STDAPPLINF_PAGE] ({ commit }, page) {
      let indexDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
      }
      commit(types.SET_STDAPPLINF_INDEX_DISP, indexDisp)
    },
    [types.RECEIVED_STDAPPLINF_COLUMNS_LABELS] ({ commit }) {
      stdapplinf.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_STDAPPLINF_COLUMNS, data.labels)
          commit(types.SET_STDAPPLINF_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_STDAPPLINF_INDEX] ({ commit }, searchParams) {
      let emptyTable = {
        total: 0,
        rows: []
      }
      commit(types.SET_STDAPPLINF_TAPPOINF, emptyTable)
      stdapplinf.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_STDAPPLINF_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_STDAPPLINF_TAPPOINF] ({ commit }, searchParams) {
      stdapplinf.getTappoinf(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_STDAPPLINF_TAPPOINF, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/stdapplinf/index.js